/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { config, SETTING_KEY } from '../../config/Config';
toast.configure();

const ToggleCITC = memo(({ setCitc, citc }) => {
  const { t } = useTranslation();

  const getSetting = async () => {
    const resp = await axios.get(config.API_URL.SETTING.GET, {
      params: {
        key: SETTING_KEY.TOGGLE_CITC,
      },
      headers: config.headers,
    });
    const { data } = resp;
    const { setting } = data;
    setCitc({
      isOn: setting.isOn || false,
    });
  };

  useEffect(() => {
    getSetting();
  }, []);

  const handlerChange = (e) => {
    const newValue = {
      ...citc,
      [e.target.name]: e.target.checked,
    };
    setCitc(newValue);
  };

  return (
    <>
      <div className="setting">
        <h3>{t('integration_to_CITC')}:</h3>
        <div className="row flex items-center gap-x-4">
          <label className="switch">
            <input checked={citc.isOn} type="checkbox" name="isOn" onChange={handlerChange} />
            <span className="slider round"></span>
          </label>
        </div>
      </div>
    </>
  );
});

export default ToggleCITC;
